// extracted by mini-css-extract-plugin
export var contentContainer = "mediaBlurb-module--contentContainer--9fda7";
export var leftContainer = "mediaBlurb-module--leftContainer--bcad4";
export var mediaBlurbBlock = "mediaBlurb-module--mediaBlurbBlock--8585c";
export var mediaBlurbContainer = "mediaBlurb-module--mediaBlurbContainer--a9e6b";
export var mediaBlurbContentSection = "mediaBlurb-module--mediaBlurbContentSection--4df08";
export var rightContainer = "mediaBlurb-module--rightContainer--70792";